import { useState } from 'react';
import { MucBaoCao } from './MucBaoCao';
import { MucDonHang } from './MucDonHang';
import { MucGiamGia } from './MucGiamGia';
import { MucNhanVien } from './MucNhanVien';
import { MucNhatKy } from './MucNhatKy';
import { MucSanPham } from './MucSanPham';
import { MucTonKho } from './MucTonKho';
import type { NguoiDung } from '../chung/kieu';

/**
 * Màn quản lý — máy bàn, một cột dọc chọn mục, phần còn lại là nội dung.
 *
 * 🔴 Admin là chỗ DUY NHẤT sửa được thứ ảnh hưởng tới tiền: giá bán, tồn kho,
 *    giảm giá, tài khoản. Nên mọi thao tác không quay lui được đều phải hỏi lại
 *    và nói RÕ hậu quả — không hỏi "chắc chưa?" mà nói thẳng cái gì sẽ đổi.
 */
/*
 * 🔴 `chiAdmin` là RÀO CHẮN CỦA GIAO DIỆN, không phải rào chắn thật.
 *
 *    Cả ba mục đánh dấu ở đây đều đụng tới tiền hoặc tới người: doanh thu và
 *    năng suất từng nhân viên, tài khoản và mật khẩu, toàn bộ đơn hàng. Backend
 *    mới là chỗ cưỡng chế — `@ChiVai(ADMIN)` trên `bao-cao`, `nhan-vien` và
 *    `don`. Quản lý kho gọi thẳng API vẫn ăn 403.
 *
 *    Ẩn ở đây chỉ để họ không nhìn thấy một cái nút bấm vào là báo lỗi. Đừng bao
 *    giờ để cái mảng này thành thứ DUY NHẤT chặn đường.
 *
 *    Ba mục đầu xếp trước có chủ ý: quản lý kho đăng nhập thì thấy một cột liền
 *    mạch, không phải một cột thủng lỗ chỗ.
 */
const MUC = [
  { id: 'san-pham', ten: 'Sản phẩm', phu: 'Giá · nhóm', chiAdmin: false },
  { id: 'ton-kho', ten: 'Tồn kho', phu: 'Nhập hàng · kiểm kê', chiAdmin: false },
  // Tab Giảm giá từng bị ẩn (tạm, comment) — bật lại 15/09 theo yêu cầu chủ dự án.
  // Backend chưa bao giờ tắt: máy tính giảm giá vẫn chạy và có suite riêng.
  { id: 'giam-gia', ten: 'Giảm giá', phu: 'Chương trình ưu đãi', chiAdmin: false },
  { id: 'don-hang', ten: 'Đơn hàng', phu: 'Mọi đơn · chỉ xem', chiAdmin: true },
  { id: 'nhan-vien', ten: 'Nhân viên', phu: 'Tài khoản · mật khẩu', chiAdmin: true },
  { id: 'bao-cao', ten: 'Báo cáo', phu: 'Doanh thu · năng suất', chiAdmin: true },
  // Chỉ OWNER (15/09). Backend cũng chặn 403 — nút ẩn chỉ để đỡ chướng mắt.
  { id: 'nhat-ky', ten: 'Nhật ký', phu: 'Ai làm gì, lúc nào', chiAdmin: true, chiOwner: true },
] as const;

type MaMuc = (typeof MUC)[number]['id'];

export function ManAdmin({ toi }: { toi: NguoiDung }) {
  const [muc, datMuc] = useState<MaMuc>('san-pham');
  const duocXem = MUC.filter(
    (m) => (!m.chiAdmin || toi.vaiTro === 'ADMIN') && (!('chiOwner' in m && m.chiOwner) || toi.owner),
  );

  return (
    <div style={{ flex: 1, display: 'flex', gap: 14, minHeight: 0 }}>
      <nav
        className="noi troi-len"
        style={{
          width: 232,
          flexShrink: 0,
          padding: 14,
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
        }}
      >
        {duocXem.map((m) => (
          <button
            key={m.id}
            onClick={() => datMuc(m.id)}
            className={muc === m.id ? 'lom-nho' : 'noi-nho'}
            style={{ textAlign: 'left', padding: '13px 16px', display: 'block' }}
          >
            <div style={{ fontWeight: 700, color: muc === m.id ? 'var(--nhan)' : undefined }}>
              {m.ten}
            </div>
            <div style={{ fontSize: 11, color: 'var(--chu-3)', marginTop: 3 }}>{m.phu}</div>
          </button>
        ))}
      </nav>

      {/* `key` theo mục: đổi mục thì dựng lại từ đầu, nên không mang theo bộ lọc
          hay ô đang gõ dở của mục trước. */}
      <div key={muc} style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        {muc === 'san-pham' && <MucSanPham />}
        {muc === 'ton-kho' && <MucTonKho />}
        {muc === 'giam-gia' && <MucGiamGia />}
        {muc === 'don-hang' && <MucDonHang />}
        {muc === 'nhan-vien' && <MucNhanVien toi={toi} />}
        {muc === 'bao-cao' && <MucBaoCao />}
        {muc === 'nhat-ky' && <MucNhatKy />}
      </div>
    </div>
  );
}
